'use strict';
import {module} from '../app';

module.service('timedMessageService', ['modalService', 'authService', 'localStorage', 'throttle', 'techpadConfig', '$ionicLoading', '$timeout', function (modalService, authService, localStorage, throttle, techpadConfig, $ionicLoading, $timeout) {

  let expiresAt;
  let warnAt;
  let expiresIn;
  let warnIn;
  let modalShown = false;
  let throttledResetTimer;
  let timeoutId;

  let initPageTouchHandling = function () {
    document.body.addEventListener('mousedown', function (e) {
      if (!modalShown)
        throttledResetTimer();
    }, false)

    document.body.addEventListener('touchstart', function (e) {
      if (!modalShown)
        throttledResetTimer();
    }, false)
  };

  let expireSession = function () {
    modalShown = true;
    $timeout(function () {
      modalService.showAlert('Your session was timed out due to no activity. You will be logged out from system', function () {
        $ionicLoading.hide();
        authService.logout();
        modalShown = false;
        throttledResetTimer();
        timer();
      }, 'timeout-error-message');
    });
  };

  let timer = function () {
    timeoutId = window.setTimeout(function () {
      timeoutId = null;
      let now = new Date();
      if (!authService.loggedIn) {
        throttledResetTimer();
        timer();
      } else if (now > expiresAt) {
        // show expired modal
        expireSession();

      } else if (now > warnAt && now < expiresAt) {

        let seconds = Math.round((expiresAt - now) / 1000);
        let minutes = Math.floor(seconds / 60);
        seconds = seconds % 60;
        let timeStr = (minutes > 0 ? minutes + ' minutes, ' : '') + (seconds + ' seconds');

        if (!modalShown) {
          // show almost expired modal
          $timeout(function () {
            modalService.showAlert('Your session will be timed out in ' + timeStr + '. <br />Please make sure to save data if you are in the middle or click Yes to continue current session.',
              function (res) {
                modalShown = false;
                throttledResetTimer();
              }, 'timeout-error-message');
          });
          modalShown = true;
        }
        timer();
      } else {
        timer();
      }

    }, 1000);
  };

  let service = {
    startTimer: function () {
      expiresIn = localStorage.get('session_expiresIn') || 15;
      warnIn = localStorage.get('session_warnIn') || 10;

      throttledResetTimer = throttle(1000, service.resetTimer);
      initPageTouchHandling();
      let expiresAtValue = localStorage.get('session_expiresAt');
      if (!!expiresAtValue && new Date() > new Date(expiresAtValue)) {
        expireSession();
      } else {
        throttledResetTimer();
        timer();
      }
    },
    resetTimer: function () {
      let now = new Date();
      expiresAt = new Date(now.getTime() + (expiresIn) * 60000);
      warnAt = new Date(now.getTime() + (warnIn) * 60000);
      localStorage.set('session_expiresAt', expiresAt);
      //console.log('reset timer: ' + expiresAt);
    },
    resumeTimer: function () {
      if (!timeoutId) {
        timer();
      }
    },

    updateTimeouts: function () {
      techpadConfig.init().then(function () {
        warnIn = techpadConfig.settings.SessionWarnTimeout || 15;
        expiresIn = techpadConfig.settings.SessionExpirationTimeout || 10;
        localStorage.set('session_warnIn', warnIn);
        localStorage.set('session_expiresIn', expiresIn);
        throttledResetTimer();
      });

    }
  };

  return service;
}]);



// WEBPACK FOOTER //
// ./src/scripts/services/timedMessage.js